__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/366dbb8cebee07893de6cf28f608926c66c1abe6/_next/";